// extracted by css-extract-rspack-plugin
export default {"modalContainer":"luUtSa","active":"WDsZ1m","buttonIcon":"l_D_KZ","result":"MeCaib","flex":"BfTEQZ","text":"yjWQvE"};